import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { GAnalyticsService } from 'src/app/services/g-analytics.service';
import { MenuCotacaoItem, MenuCotacaoSubItem } from './menu-nova-cotacao';

type ToggleEvents = 'mouseenter' | 'mouseleave' | 'click';
@Component({
  selector: 'app-menu-nova-cotacao',
  templateUrl: './menu-nova-cotacao.component.html',
  styleUrls: ['./menu-nova-cotacao.component.scss'],
})
export class MenuNovaCotacaoComponent {

  @Input() menusCotacao: MenuCotacaoItem[] = [];
  public isMenuOpen: boolean = false;

  constructor(
    private router: Router,
    private gAnalytics: GAnalyticsService
  ) {}

  openPage(item: MenuCotacaoSubItem) {
    this.router.navigateByUrl(item.url);

    const {type, category, label} = item.analytics;
    this.gAnalytics.analyticsMonitor(type, category, label);

    // Fecha o menu
    this.isMenuOpen = false;
  }
}
